// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + ({"151":"FavSearch","290":"FavList","324":"FavDetail"}[chunkId] || chunkId) + "." + {"70":"79a9f45d","151":"b3029598","290":"5eb675f5","324":"6e4a6c62","527":"1b1b9cbe"}[chunkId] + ".css";
};